angular.module('jv.Admin.Users')
    .controller('jvAdminUsersAgencyListController',
        ['$scope', 'agencyUserSVC', '$route', 'breadcrumbsResolve', 'enumToValueMap', 'TemplateLoader', 'addToReqModalConfig', 'commonListActionsFAC',
            function($scope, agencyUserSVC, $route, breadcrumbsResolve, enumToValueMap, TemplateLoader, addToReqModalConfig, commonListActionsFAC){
                $scope.flags.expanded = true;
                $scope.selectedRows=[];
                $scope.map = enumToValueMap;
                $scope.showMsg($scope.params.message);
                // Set the default value for agencyCapacityAvailable
                $scope.agencyCapacityAvailable = false;
                $scope.filters = {};
                $scope.defaultFilters = {
                    searchString: '',
                    sortBy: 'FirstName',
                    inviteStatus: '',
                    order: 'asc',
                    page: 0,
                    pageSize: 20
                };
                $scope.employeeDefaultSelect = $scope.employeeSelect = agencyUserSVC.employeeSelect;
                // Ensure that the filters are loaded before making the GET request
                var hasFiltersLoaded = false;

                $scope.agencyPageInfo = {
                    inviteStatus: []
                };

                $scope.getAgencyPageInfo=function(){
                	agencyUserSVC.getAgencyListDetails(function(response){
                        $scope.defaultFilters.pageSize = response.agencySearchInfo.paginationSize;
                        $scope.filters = angular.copy($scope.defaultFilters);
                        hasFiltersLoaded = true;
                        $scope.agencyPageInfo.inviteStatus = response.agencySearchInfo.inviteStatus;
                    });
                }

                // Breadcrumb Config Array
                $scope.breadcrumbsConfig = breadcrumbsResolve;

                // Sort options
                $scope.sortListConfig = {
                    sortOptions: [
                        {
                            value: i18n['FIRST_NAME'],
                            id: 'FirstName'
                        },
                        {
                            value: i18n['LAST_NAME'],
                            id: 'LastName'
                        },
                        {
                            value: i18n['EMAIL'],
                            id: 'Email'
                        },
                        {
                            value: i18n['COMPANY'],
                            id: 'Company'
                        }
                    ],
                    sortOrder: [
                        {
                            value: i18n['ASCENDING'],
                            id: 'asc'
                        },
                        {
                            value: i18n['DESCENDING'],
                            id: 'desc'
                        }],
                    selectedOption: 0,
                    selectedSortOrder: 0
                };

                // Watching sortListConfig for selected option
                $scope.$watch('sortListConfig.selectedOption', function(newValue, oldValue) {
                    if (angular.isDefined(newValue) && $scope.filters && $scope.filters.sortBy) {
                        $scope.filters.sortBy = $scope.sortListConfig.sortOptions[newValue].id;
                    }
                });

                // Watching sortListConfig for selected sort order
                $scope.$watch('sortListConfig.selectedSortOrder', function(newValue, oldValue) {
                    if (angular.isDefined(newValue) && $scope.filters && $scope.filters.order) {
                        $scope.filters.order = $scope.sortListConfig.sortOrder[newValue].id;
                    }
                });

                $scope.actionListConfig = {
                    actionTitle: i18n['ACTIONS'],
                    sortOptions: [
                        {
                            value: i18n['SEND_INVITE'],
                            id: 0
                        },
                        {
                            value: i18n['SEND_MESSAGE'],
                            id: 1
                        },
                        {
                            value: i18n['REMOVE'],
                            id: 2
                        }
                    ],
                    selectedOption: -1
                };

                $scope.actionListBottomConfig = angular.copy($scope.actionListConfig);

                $scope.$watch('actionListConfig.selectedOption', function(newValue, oldValue) {
                    if (angular.isDefined(newValue) && newValue != -1) {
                        triggerAction(newValue, $scope.actionListConfig);
                         $scope.actionListConfig.selectedOption  = -1;
                    }
                });

                $scope.$watch('actionListBottomConfig.selectedOption', function(newValue, oldValue) {
                    if (angular.isDefined(newValue) && newValue != -1) {
                        triggerAction(newValue, $scope.actionListBottomConfig);
                        $scope.actionListBottomConfig.selectedOption = -1;
                    }
                });

                var triggerAction = function(index, sourceList){
                    var selectedActionId = sourceList.sortOptions[index].id;
                    if($scope.changeAgency(selectedActionId, sourceList) === -1) {
                        sourceList.message = i18n['NO_AGENCY_SELECTED'];
                        sourceList.selectedOption = -1;
                    }
                };

                $scope.getAgencyPageInfo();
                $scope.selectedAgency=[];
                $scope.messageModal={};
                $scope.removeMsgModal={};
                $scope.userReqList={};
                $scope.checkAll=false;
                $scope.sortByText='First Name';
                $scope.isPaginate=false;
                $scope.$watch("filters",function(newVal, oldVal){
                    if(newVal){
                        if(!$scope.isPaginate){
                            $scope.filters.page=0;
                        }

                        if (hasFiltersLoaded) {
                            $scope.refreshSearch();
                        }
                    }
                },true);
                $scope.refreshSearch=function(isFastRead){
                    var readMode=false;
                    if(isFastRead || ($scope.urlParams().readMode == 0) || ($scope.params && $scope.params.message)){
                        readMode=true;
                    }
                    $scope.flags.loading=true;
                    $scope.checkAll = false;
                    $scope.selectedAgency = [];

                    var postParams = angular.copy($scope.filters);
                    if(postParams.inviteStatus == 10) {
                        postParams.inviteStatus = [1,3];
                    }
                    commonListActionsFAC.sortByRelevance($scope.filters, $scope.sortListConfig, i18n.RELEVANCE);
                    agencyUserSVC.getAgencyList(postParams, function(response){
                        $scope.flags.loading=false;

                        if (response && response.agencySearchDetails) {
                            $scope.agencyCapacityAvailable = response.agencySearchDetails.agencyCapacityAvailable;
                            $scope.agencyList=response.agencySearchDetails.agencies;
                            $scope.resultCount=response.agencySearchDetails.resultCount;
                        }

                        $scope.isPaginate=$scope.isPaginate?false:true;
                        if ($scope.filters.searchString) {
                            $scope.queryString=$scope.filters.searchString;
                        }
                    },readMode)
                };

                $scope.search=function(){
                    $scope.filters.searchString = $scope.queryString;
                    $scope.filters.sortBy = $scope.queryString ? 'Relevance' : $scope.defaultFilters.sortBy;
                };

                $scope.resetSearch=function(){
                    $scope.queryString = '';
                    $scope.sortListConfig.selectedOption = 0;
                    $scope.selectedAgency=[];
                    $scope.checkAll = false;
                    $scope.sortListConfig.selectedSortOrder = 0;
                    $scope.getAgencyPageInfo();
                };

                //Agency list pagination
                $scope.recordsEnd = function() {
                    if ($scope.filters) {
                        return Math.min($scope.filters.pageSize * ($scope.filters.page + 1), $scope.resultCount);
                    }
                };

                $scope.recordsStart = function() {
                    if ($scope.filters) {
                        return $scope.filters.pageSize * $scope.filters.page + 1;
                    }
                };
                $scope.next = function() {
                    if ($scope.filters.page < $scope.resultCount / $scope.filters.pageSize - 1) {
                        //Clear any previously selected users from the list
                        $scope.clearSelectedUserList();
                        $scope.isPaginate=true;
                        $scope.filters.page++;
                    }
                };
                $scope.prev = function() {
                    if ($scope.filters.page !== 0) {
                        //Clear any previously selected users from the list
                        $scope.clearSelectedUserList();
                        $scope.isPaginate= true;
                        $scope.filters.page--;
                    }
                };
                $scope.clearSelectedUserList = function(){
                    $scope.selectedAgency = [];
                };

              //function to create object for all selected Agencies in grid list
                var getSelectedAgencies=function(){
                    angular.forEach($scope.selectedAgency, function(value,index){
                        if(value){
                            $scope.selectedRows.push($scope.agencyList[index]);
                        }
                    });
                }

                $scope.setCheckAll = function() {
                   if($scope.agencyList) {
                       angular.forEach($scope.agencyList,function(employee,index) {
                           $scope.selectedAgency[index] = $scope.checkAll;
                       });
                   }
                 };

                $scope.checkSelection = function() {
                    var checkList = true;
                    if(objectSize($scope.selectedAgency) === $scope.agencyList.length){
                        angular.forEach($scope.selectedAgency, function(checkFlag) {
                           checkList &= checkFlag;
                        });
                    }else{
                        checkList = false;
                    }
                    $scope.checkAll = !!checkList;
                };

                $scope.$watch('messageModal.template',function(newVal, oldVal){
                    if(newVal){
                        angular.forEach($scope.messageModal.templates, function(templt){
                            if(templt.eid==newVal['eid']){
                                $scope.messageModal.subject= templt.subject;
                                $scope.messageModal.body= templt.body;
                            }
                        });
                    }else{
                        $scope.messageModal.subject= '';
                        $scope.messageModal.body='';
                    }
                },true);

                $scope.sendAgencyMessage= function(messageType){
                    $scope.flags.loading=true;
                    if(messageType=='INVITE' || messageType=='NOTE'){
                        $scope.messageModal.checkdata = false;
                        if(!$scope.messageModal.subject|| ($scope.messageModal.subject && $scope.messageModal.subject.trim().length === 0))
                        {
                            $scope.messageModal.checkdata = true;
                            $scope.flags.loading=false;
                            return;
                        }
                        if(!$scope.messageModal.body|| ($scope.messageModal.body && $scope.messageModal.body.trim().length === 0))
                        {
                            $scope.messageModal.checkdata = true;
                            $scope.flags.loading=false;
                            return;
                        }
                    }
                    else{
                        $scope.removeMsgModal.checkdata = false;
                        $scope.removeMsgModal.checkSubject = false;
                        if($scope.removeMsgModal.isToSendMail){
                            if(!$scope.removeMsgModal.subject|| ($scope.removeMsgModal.subject && $scope.removeMsgModal.subject.trim().length === 0))
                            {
                                $scope.removeMsgModal.checkdata = true;
                                $scope.flags.loading=false;
                                return;
                            }
                            if(!$scope.removeMsgModal.body|| ($scope.removeMsgModal.body && $scope.removeMsgModal.body.trim().length === 0))
                            {
                                $scope.removeMsgModal.checkdata = true;
                                $scope.flags.loading=false;
                                return;
                            }
                        }
                    }

                    if(messageType==='INVITE'){
                        var postParams={};
                        postParams['to']= [];
                        postParams['jobIds']= [];
                        angular.forEach($scope.selectedRows, function(agency) {
                            if($scope.map.inviteStatuses[agency.invitationStatus.key] != 'INVITE_STATUS_ACCEPTED') {
                                postParams['to'].push(agency.EId);
                            }
                        });
                        postParams['subject']=$scope.messageModal.subject;
                        postParams['content']= $scope.messageModal.body;
                        if($scope.userReqList){
                            for(var reqEId in $scope.userReqList){
                                if($scope.userReqList[reqEId]){
                                    postParams['jobIds'].push(reqEId);
                                }
                            }
                        }
                        /*BE expects locale to be sent to determine language for Email header/footer*/
                        if($scope.messageModal && $scope.messageModal.template){
                            postParams['locale'] = $scope.messageModal.template['locale'];
                        }
                        agencyUserSVC.sendInvite(postParams, function(response){
                            $scope.messageModal={};
                            $scope.userReqList={};
                            $scope.selectedAgency={};$scope.flags.loading=false;
                            $scope.showMsg('INVITE_SENT');$scope.refreshSearch(true);
                        });

                    }else if(messageType==='NOTE'){
                        var postParams={};
                        postParams['to']= [];
                        angular.forEach($scope.selectedRows, function(employee){
                            postParams['to'].push(employee.EId);
                        });
                        postParams['subject']=$scope.messageModal.subject;
                        postParams['content']= $scope.messageModal.body;
                        agencyUserSVC.saveNote(postParams, function(response){
                            $scope.messageModal={};
                            $scope.selectedAgency={};$scope.flags.loading=false;
                            $scope.checkAll = false;
                            $scope.showMsg('MESSAGE_SENT');
                        });
                    }
                    else if(messageType==='REMOVE'){
                        if($scope.removeMsgModal.isToSendMail){
                            var postParams={};
                            postParams['to']= [];
                            angular.forEach($scope.selectedRows, function(employee){
                                postParams['to'].push(employee.EId);
                            });
                            postParams['subject']=$scope.removeMsgModal.subject;
                            postParams['content']= $scope.removeMsgModal.body;
                            postParams['sendEmail']= $scope.removeMsgModal.isToSendMail;

                            /*BE expects locale to be sent to determine language for Email header/footer*/
                            if($scope.removeMsgModal && $scope.removeMsgModal.template){
                                postParams['locale'] = $scope.removeMsgModal.template['locale'];
                            }
                            agencyUserSVC.removeUser(postParams, function(response){
                                $scope.removeMsgModal={};
                                $scope.selectedAgency={};
                                $scope.flags.loading=false;
                                $scope.showMsg('AGENCY_USERS_REMOVED');
                                $scope.refreshSearch(true);
                            });
                        }
                        else{
                            var postParams={};
                            postParams['sendEmail']= $scope.removeMsgModal.isToSendMail;
                            postParams['userIds']=postParams['to']= [];
                            angular.forEach($scope.selectedRows, function(employee){
                                postParams['to'].push(employee.EId);
                            });
                            postParams['userIds']=postParams['to'];
                            agencyUserSVC.removeUser(postParams, function(response){
                                $scope.removeMsgModal={};
                                $scope.selectedAgency={};
                                $scope.flags.loading=false;
                                $scope.showMsg('AGENCY_USERS_REMOVED');
                                $scope.refreshSearch(true);
                            });
                        }
                    }
                }
                $scope.showAgencyMessage=function(messageType){
                    //getSelectedAgencies();
                    if($scope.selectedRows.length){
                        if(messageType=='invite'){
                            $scope.flags.loading=true;
                            $scope.messageModal={
                                type: 'INVITE',
                                show:true,
                                isAgency:true,
                                showLinks: false,
                                headText: i18n['SEND_INVITE'],
                                showCC: false,
                                showBCC: false,
                                showLinks:false,
                                dontshowTemplate:false,
                                agencyType:true,
                                templates:[],
                                typeInvite:true,
                                templatePlaceHolder: i18n['MESSAGE_TO_AGENCY'],
                                subjectPlaceHolder: i18n['MESSAGE_TO_AGENCY'] + ' ' + i18n['DEFAULT_HEADER']
                            };
                            agencyUserSVC.getInviteTemplates(function(response){
                                $scope.messageModal.templates= $scope.select2Options.setTemplates(response.agencyInviteTemplate);
                                angular.forEach($scope.messageModal.templates, function(templt){
                                    if(templt['default']){
                                        $scope.messageModal.template= templt;
                                        $scope.messageModal.subject= templt.subject;
                                        $scope.messageModal.body= templt.body;
                                    }
                                });
                                $scope.flags.loading=false;
                            });

                        }else if(messageType=='note'){

                            $scope.messageModal={
                                type: 'NOTE',
                                show:true,
                                isAgency:true,
                                showLinks: true,
                                headText: i18n['SEND_MESSAGE'],
                                showCC: false,
                                showBCC: false,
                                agencyType:true,
                                showLinks:false,
                                dontshowTemplate:true,
                                templates:[],
                                templatePlaceHolder: i18n['MESSAGE_TO_AGENCY'],
                                subjectPlaceHolder: i18n['MESSAGE_TO_AGENCY'] + ' ' +  i18n['DEFAULT_HEADER']
                            };

                        }
                    }
                };
                $scope.$watch('removeMsgModal.template',function(newVal, oldVal){
                    if(newVal){
                        angular.forEach($scope.removeMsgModal.templates, function(templt){
                            if(templt.eid==newVal.eid){
                                $scope.removeMsgModal.subject= templt.subject;
                                $scope.removeMsgModal.body= templt.body;
                            }
                        });
                    }else{
                        $scope.removeMsgModal.subject= '';
                        $scope.removeMsgModal.body='';
                    }
                },true);
                $scope.showAgencyRemove= function(){
                    //getSelectedAgencies();
                    if($scope.selectedRows.length){
                        $scope.flags.loading=true;
                        $scope.removeMsgModal={
                            type: 'REMOVE',
                            show:true,
                            isAgency:true,
                            isToSendMail:false,
                            showLinks: false,
                            headText: i18n['REMOVE_AGENCY_USERS'],
                            showCC: false,
                            showBCC: false,
                            showLinks:false,
                            dontshowTemplate:false,
                            templates:[],
                            templatePlaceHolder: i18n['MESSAGE_TO_AGENCY'],
                            subjectPlaceHolder: i18n['MESSAGE_TO_AGENCY'] + ' ' + i18n['DEFAULT_HEADER']
                        };
                        agencyUserSVC.getRemoveTemplates(function(response){
                            $scope.removeMsgModal.templates= $scope.select2Options.setTemplates(response.agencyRemoveTemplate);
                            angular.forEach($scope.removeMsgModal.templates, function(templt){
                                if(templt['default']){
                                    $scope.removeMsgModal.template= templt;
                                    $scope.removeMsgModal.subject= templt.subject;
                                    $scope.removeMsgModal.body= templt.body;
                                }
                            });
                            $scope.flags.loading=false;
                        });
                    }
                }

                $scope.changeAgency=function(modal,id){
                    $scope.selectedRows=[];
                    getSelectedAgencies();
                    if($scope.selectedRows.length){
                        switch(modal){
                            case 0:
                                if($scope.validateInviteList()) {
                                    $scope.showAgencyMessage('invite');
                                } else {
                                    //Employee already accepted invite
                                    $scope.$root.modal = {
                                        show:true,
                                        buttons:[
                                            {
                                                label: i18n['CLOSE'],
                                                title:i18n['CLOSE'],
                                                click: function(){
                                                    $scope.$root.modal.show = false;
                                                }
                                            }
                                        ],
                                        title: i18n['SEND_INVITE'],
                                        body: i18n['AGENCY_ALREADY_ACCEPTED_INVIE'],
                                        cancel: function(){
                                            $scope.$root.modal.show = false;
                                        }
                                    };
                                }
                                break;
                            case 1:
                                $scope.showAgencyMessage('note');
                                break;
                            case 2:
                                $scope.showAgencyRemove();
                                break;
                        }
                    } else{
                        return -1;
                    }
                }

                $scope.modals = {
                    addToReq: {
                        show: false,
                        fetch: false
                    }
                };
                $scope.templates = TemplateLoader.register({
                    addToReq: '/jhire/modules/candidates/modals/addToReq.html'
                });

                $scope.showReqList=function(modalType){
                    $scope.currentModal = modalType;
                    $scope.messageModal.checkdata = false;
                    if(!$scope.messageModal.subject|| ($scope.messageModal.subject && $scope.messageModal.subject.trim().length === 0))
                    {
                        $scope.messageModal.checkdata = true;
                        $scope.flags.loading=false;
                        return;
                    }
                    if(!$scope.messageModal.body|| ($scope.messageModal.body && $scope.messageModal.body.trim().length === 0))
                    {
                        $scope.messageModal.checkdata = true;
                        $scope.flags.loading=false;
                        return;
                    }
                    var modal='addToReq';
                    agencyUserSVC.getRequisitionsFilter(function(data){
                        $scope.modals[modal].fetch = true;
                        $scope.formTemplateConfig = addToReqModalConfig($scope.postReqs, data);
                        $scope.formTemplateConfig.list.post.button.label = i18n['SEND'];
                        TemplateLoader.load(modal).then(function(){
                           $scope.modals[modal].show = true;
                        });
                    });
                };

                $scope.hideModals = function(){
                    angular.forEach($scope.modals, function(val, key) {
                         $scope.modals[key].show = false;
                    });
                };

                $scope.postReqs = function(modalData){
                    $scope.userReqList = modalData.selectedReqEId;
                    $scope.sendAgencyMessage($scope.currentModal);
                    $scope.hideModals();
                };

                $scope.formTemplateConfig = addToReqModalConfig($scope.postReqs, {});

                $scope.validateInviteList = function() {
                    var userInviteList = [];
                    var userAcceptedInviteList = [];
                    angular.forEach($scope.selectedRows, function(user,key) {
                        if($scope.map.inviteStatuses[user.invitationStatus.key] != 'INVITE_STATUS_ACCEPTED') {
                            userInviteList.push(user);
                        } else {
                            userAcceptedInviteList.push(user);
                        }
                    });
                    $scope.totalInvite = $scope.selectedRows.length;
                    $scope.selectedRows = userInviteList;
                    $scope.invalidAgencyInvite = userAcceptedInviteList.length;

                    if(userInviteList.length > 0) {
                        return true;
                    }
                    return false;
                };
            }
        ]);
